import React from 'react';

interface EndingSoonRangeControlsProps {
  useCustomRange: boolean;
  onUseCustomRangeChange: (value: boolean) => void;
  endsFrom: string;
  endsTo: string;
  onEndsFromChange: (value: string) => void;
  onEndsToChange: (value: string) => void;
  idPrefix: string;
}

const EndingSoonRangeControls: React.FC<EndingSoonRangeControlsProps> = ({
  useCustomRange,
  onUseCustomRangeChange,
  endsFrom,
  endsTo,
  onEndsFromChange,
  onEndsToChange,
  idPrefix,
}) => (
  <div className="flex flex-wrap gap-3 items-end">
    <div className="flex flex-col gap-1">
      <span className="text-xs font-medium text-gray-500 uppercase">Ends within</span>
      <div className="inline-flex rounded-md shadow-sm">
        <button
          type="button"
          onClick={() => onUseCustomRangeChange(false)}
          className={`px-3 py-1.5 text-sm font-medium border-r border-gray-200 rounded-l-md ${
            !useCustomRange
              ? 'bg-blue-600 text-white'
              : 'bg-white text-gray-700 hover:bg-gray-50'
          }`}
        >
          Next 7 days
        </button>
        <button
          type="button"
          onClick={() => onUseCustomRangeChange(true)}
          className={`px-3 py-1.5 text-sm font-medium rounded-r-md ${
            useCustomRange
              ? 'bg-blue-600 text-white'
              : 'bg-white text-gray-700 hover:bg-gray-50'
          }`}
        >
          Custom
        </button>
      </div>
    </div>

    {useCustomRange && (
      <>
        <div className="w-[150px]">
          <label
            htmlFor={`${idPrefix}-ends-from`}
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Ends from
          </label>
          <input
            id={`${idPrefix}-ends-from`}
            type="date"
            className="w-full p-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
            value={endsFrom}
            max={endsTo || undefined}
            onChange={(e) => onEndsFromChange(e.target.value)}
          />
        </div>
        <div className="w-[150px]">
          <label
            htmlFor={`${idPrefix}-ends-to`}
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Ends to
          </label>
          <input
            id={`${idPrefix}-ends-to`}
            type="date"
            className="w-full p-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
            value={endsTo}
            min={endsFrom || undefined}
            onChange={(e) => onEndsToChange(e.target.value)}
          />
        </div>
      </>
    )}
  </div>
);

export default EndingSoonRangeControls;
